import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Panchangam = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ height: "80vh" }}
    >
      <Card
        style={{ border: "1px solid #ffc33b" }}
        className="rotating-border-card text-center p-1 shadow-lg"
      >
        <Card.Body>
          <h2 className="mb-3">{t("BRTH.CHART")}</h2>
          <p className="lead">{t("CON.TO.GET.PLSE.ENTR.BRT.DETLS")}</p>
          <Button
            className="all_btn1"
            onClick={() => {
              navigate("/panchangamview");
            }}
          >
            {t("CON.ENTR.BRTH.DETAILS")}
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Panchangam;
